/* eslint-disable react/style-prop-object */
import { Button } from 'crux';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import styled, { withTheme } from 'styled-components';
import at from 'lodash/at';
import get from 'lodash/get';
import isObject from 'lodash/isObject';
import isPlainObject from 'lodash/isPlainObject';
import isArray from 'lodash/isArray';
import flattenDeep from 'lodash/flattenDeep';
import TextElement from '../TextElement';
import {
  getNextListItemForm,
  deleteBeneficiary,
  addListItem,
  setListIndex,
  setReflexiveListIndex,
  listSectionUpdates,
  closeAddListForm,
} from '../../../redux/actions/listQuestion';
// eslint-disable-next-line import/no-cycle
import ListItemCard from './ListItemCard';
import { insertReflexiveQuestions } from '../../../utils';
import { getCSSVariables } from '../../../cruxComponents/utils';
// import { getEnableAdd } from '../../../redux/selector/validations';
import {
  setCurrentEditListIndices,
  setOuterListActionButton,
} from '../../../redux/actions/questions';

const ListQuestionCardWrapper = styled.div`
  margin-bottom: 30px;
  ${({ className }) => className === 'mgt90' && 'margin-top: -90px'};
  & > h3 {
    ${({ className }) => className === 'mgt90' && 'width: 75%'};
  }
`;

// Handles reflexLevel condition for displaying Contingent Beneficiary
const Wrapper = styled.div`
  ${({ reflexLevel, isReview, hideReflexWrapper }) => {
    if (hideReflexWrapper) return '';
    return `
      ${
        (reflexLevel < 1 || (reflexLevel === 1 && isReview)) &&
        `
        background: rgba(226, 226, 226, 1);
        margin-right: -100px;
      `
      }
      margin-left: ${isReview ? '0px' : '-100px'};
      margin-right: ${isReview ? '0px' : '-100px'};
      margin-bottom: 20px;
      ${({ margin, padding }) =>
        `
        margin:${
          margin?.[0]?.['listQuestionCard-wrapper'] || margin?.[1]?.['listQuestionCard-wrapper']
        };
        padding:${
          padding?.[0]?.['listQuestionCard-wrapper'] || padding?.[1]?.['listQuestionCard-wrapper']
        };
      `}
    `;
  }}
`;

const AddListItemButton = styled.button`
  ${({ addListItemDashedButton }) =>
    addListItemDashedButton ||
    `
    border: 2px dashed rgba(41, 101, 204, 1);
    border-radius: 8px;
    padding: 20px;
    color: rgba(41, 101, 204, 1);
  `}
  ${({ addListItemTheme, disabled }) => addListItemTheme && disabled && 'color: #767676'};
  ${({ addListItemDashedButton, disabled }) =>
    disabled &&
    addListItemDashedButton?.disabledTheme &&
    `color: ${addListItemDashedButton?.disabledTheme?.color}`};
  background: transparent;
  width: 100%;
  text-align: left;
  font-size: 18px;
  &:active {
    outline: 0;
  }
  &:focus {
    outline: 0;
    border: ${({ addListItemDashedButton }) => addListItemDashedButton?.borderOnFocus};
  }
  &:disabled {
    i {
      cursor: default;
    }
  }
  @media only screen and (max-width: 767px) {
    font-size: 18px;
    padding: 10px;
  }
`;

const Icon = styled.i`
  padding-right: 10px;
`;

const toArray = (obj) => {
  return Object.keys(obj).reduce((acc, keys) => {
    if (isObject(obj[keys])) {
      acc.push(obj[keys]);
    }
    return acc;
  }, []);
};

export const getQuestions = (questionList) => {
  const parentListQuestion = questionList[0];
  const originalQuestions = get(questionList[0], 'original_questions', []);
  let questions = get(questionList[0], 'questions', []);

  // if already added list questions are not available, don't display
  if (!questions) {
    return {
      parentListQuestion,
      questions,
    };
  }
  questions = questions.map((item) => toArray(item));
  questions = questions.map((item) => insertReflexiveQuestions(item));

  return {
    parentListQuestion,
    questions,
    originalQuestions,
  };
};

const getTitleFromFormat = (listCardQuestions, formatMatch, cardIndex) => {
  if (formatMatch && isArray(formatMatch.questions) && formatMatch.format) {
    let titleStr = formatMatch.format;
    formatMatch.questions.forEach(({ id, ref, format, alias_question_id: aliasQuestionId }) => {
      const aliasQ = listCardQuestions.find(
        (ques) => ques.question_id === `${aliasQuestionId}_${cardIndex + 1}`,
      );
      const refQ =
        aliasQ ?? listCardQuestions.find((ques) => ques.question_id === `${id}_${cardIndex + 1}`);
      if (refQ) {
        let refQRes = isPlainObject(refQ.response) ? refQ.response.label : refQ.response;
        if (format) {
          const [customMethod, ...args] = format.split(',');
          refQRes =
            typeof refQRes[customMethod] === 'function' && refQRes[customMethod]
              ? refQRes[customMethod](...args)
              : refQRes;
        }
        titleStr = titleStr.replace(ref, refQRes);
      } else if (ref.toLowerCase().includes('time') && format) {
        const options = {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          hour12: false,
          timeZone: 'America/Los_Angeles',
        };
        const date = new Date(Date.UTC(2012, 11, 20, 3, 0, 0));
        titleStr = titleStr.replace(ref, new Intl.DateTimeFormat('en-US', options).format(date));
      }
    });
    return titleStr;
  }
  return '';
};

export const getListQuestionCardTitle = ({
  parentListQuestion,
  questions: listCardQuestions = [],
  index: cardIndex = 0,
}) => {
  const defaultTitle = get(
    parentListQuestion,
    ['list_titles', [cardIndex]],
    `${cardIndex + 1}. ${parentListQuestion.question_text}`,
  );
  const currentListCardQuestions = listCardQuestions[cardIndex];
  if (!currentListCardQuestions) return defaultTitle;

  const listTitleFormats = get(parentListQuestion, 'list_titles_formats', []);
  if (!listTitleFormats.length) return defaultTitle;

  // from list_titles_format get common question id among the list cards
  const listTitleCheckQuestionId = get(parentListQuestion, [
    'list_titles_formats',
    [0],
    'question_id',
  ]);
  if (listTitleCheckQuestionId) {
    const listTitleCheckQuestion = currentListCardQuestions.find(
      (q) => q.question_id === `${listTitleCheckQuestionId}_${cardIndex + 1}`,
    );
    if (!listTitleCheckQuestion) return defaultTitle;

    const listTitleCheckResponseId = isPlainObject(listTitleCheckQuestion.response)
      ? listTitleCheckQuestion.response.id
      : listTitleCheckQuestion.response;
    const formatMatch = listTitleFormats.find(
      (formatObj) => formatObj.response_id === listTitleCheckResponseId,
    );
    // build list card title based on format key using questions from formatMatch
    return getTitleFromFormat(currentListCardQuestions, formatMatch, cardIndex) || defaultTitle;
  }
  const formatMatch = listTitleFormats[0];
  return getTitleFromFormat(currentListCardQuestions, formatMatch, cardIndex) || defaultTitle;
};

const getRequiredListQIds = (questions) => {
  const reqIds = flattenDeep(questions)
    .filter((q) => q.display_type !== 'list' && !q.is_hidden)
    .filter((q) => get(q, 'validations.required.value', false))
    .map((q) => q.question_id);
  return reqIds;
};

function ListQuestionCard({
  questionList,
  listQIds,
  listId,
  handleAddListItem,
  allQuestions,
  sectionIndex,
  handleDelete,
  handleUpdate,
  updateListIndex,
  addButtonText,
  changeMode,
  reflexLevel,
  isReview,
  listParentId,
  isListAddAction,
  listEditIndex,
  listEditQId,
  // enableUpdate,
  handleCancel,
  updateReflexiveListIndex,
  nestedListProps,
  currentListAnswerIndex,
  editingChildListIndex,
  callBackButtonAction,
  ql,
  ...otherProps
}) {
  const theme = get(otherProps, 'theme.config.theme.global');
  const { listButtonsTheme, colorScheme } = theme;
  const [editIndex, updateEditIndex] = useState(-1);
  const { parentListQuestion, questions, originalQuestions } = getQuestions(questionList);
  const isListEditable = get(parentListQuestion, 'is_editable', true);

  const {
    is_item_editable: hideEditButton,
    disable_add_button: disableAddButton,
    is_expandable: isExpandable,
  } = questionList[0];
  const hideReflexWrapper = get(theme, 'hideReflexWrapper', false);
  // CSS Variables
  const cssVariables = getCSSVariables(otherProps.theme);
  const margin = at(cssVariables, ['pageOverride.margin', 'global.margin']);
  const padding = at(cssVariables, ['pageOverride.padding', 'global.padding']);
  const font = at(cssVariables, ['pageOverride.font', 'global.font']);
  if (listButtonsTheme && listButtonsTheme.addButtonTheme) {
    listButtonsTheme.addButtonTheme.themeConfiguration.font =
      font?.[0]?.['button-list-add'] || font?.[1]?.['button-list-add'];
  }

  if (Array.isArray(allQuestions) && allQuestions.length) {
    allQuestions.forEach((q) => {
      const match = questions.filter((list) => list.question_id === q.question_id);
      if (match.length) {
        q.response = match[0].response;
      }
    });
  }
  let showListActions = true;
  const isNestedQ = get(nestedListProps, 'isNestedQ', false);
  let parentListIndex = null;
  if (nestedListProps && isNestedQ) {
    showListActions = get(nestedListProps, 'showListActions', true);
    parentListIndex = get(nestedListProps, 'parentListIndex', null);
  }

  // eslint-disable-next-line
  const displayAddListItemButton =
    !disableAddButton &&
    listEditQId !== listId &&
    originalQuestions &&
    originalQuestions.length &&
    !isReview &&
    showListActions;

  if (Array.isArray(ql) && ql.length) {
    ql.forEach((q) => {
      const match = questions.filter((list) => list.question_id === q.question_id);
      if (match.length) {
        q.response = match[0].response;
      }
    });
  }

  const renderAddListItemButton = () => {
    if (listButtonsTheme && listButtonsTheme.addButtonTheme) {
      return (
        <Button
          label={ addButtonText }
          disabled={ isListAddAction || listEditIndex !== -1 }
          handleButtonClick={ () => handleAddListItem(parentListIndex, questions.length, isNestedQ) }
          color={ colorScheme }
          { ...listButtonsTheme.addButtonTheme }
        />
      );
    }
    return (
      <AddListItemButton
        name='add-list-item-button'
        onClick={ () => handleAddListItem(parentListIndex, questions.length, isNestedQ) }
        disabled={ isListAddAction || !isListEditable || listEditIndex !== -1 }
        addListItemDashedButton={ listButtonsTheme.addListItemDashedButton }
      >
        <Icon className='fa fa-plus-circle' />
        <span>{addButtonText}</span>
      </AddListItemButton>
    );
  };

  const pendingQuestions = questions.filter((list) => list[0].child_questions_pending_flag);
  const pendingQuestionsLength = pendingQuestions.length;

  return (
    <ListQuestionCardWrapper
      className={
        parentListQuestion.presentation_type === 'review' ? parentListQuestion.className : ''
      }
    >
      <TextElement
        key={ get(parentListQuestion, 'question_id', '') }
        styleType={ isReview ? 'review_heading' : 'questions_group' } // this needs to be fixed.
        text={ get(parentListQuestion, 'question_text', '') }
        sectionIndex={ sectionIndex }
      />
      {get(parentListQuestion, 'question_status_message', null) && (
        <TextElement
          key={ `${parentListQuestion.question_id}-error` }
          styleType='error'
          text={ get(parentListQuestion, 'question_status_message', null) }
          sectionIndex={ sectionIndex }
        />
      )}
      <Wrapper
        margin={ margin }
        padding={ padding }
        name='list-item-card-wrapper'
        reflexLevel={ reflexLevel }
        isReview={ isReview }
        hideReflexWrapper={ hideReflexWrapper }
        id={ `list-item-card-wrapper-${questionList[0].question_id}` }
      >
        {questions
          ? questions.map((item, index) => {
              const isEditMode =
                index === editIndex ||
                (listEditIndex === index && listEditQId === listParentId) ||
                (item[0]?.child_questions_pending_flag && item[0]?.presentation_type !== 'review');
              return (
                <ListItemCard
                  index={ index }
                  len={ questions.length }
                  reflexLevel={ reflexLevel }
                  // title={ `${index + 1 }. ${title.question_text}` }
                  title={ getListQuestionCardTitle({ parentListQuestion, questions, index }) }
                  name='list-item-card'
                  changeMode={ changeMode }
                  parentListQuestion={ parentListQuestion }
                  onDeleteClick={ () => {
                    handleDelete(index, sectionIndex, parentListIndex);
                  } }
                  onEditClick={ () => {
                    handleUpdate(sectionIndex, index, item, parentListIndex, isNestedQ);
                  } }
                  setEditIndex={ () => {
                    updateListIndex(index);
                  } }
                  sectionIndex={ sectionIndex }
                  // enableUpdate={enableUpdate}
                  isEditMode={ isEditMode }
                  updateEditIndex={ updateEditIndex }
                  listItem={ item }
                  listQIds={ listQIds }
                  listId={ listId }
                  isReview={ isReview }
                  listParentId={ listParentId }
                  setReflexiveListIndex={ (idx, id) => {
                    updateReflexiveListIndex(idx, id);
                  } }
                  handleCancel={ () =>
                    handleCancel(sectionIndex, index, item, editingChildListIndex)
                  }
                  hideEditButton={ hideEditButton }
                  hideCancelButton={ item[0]?.child_questions_pending_flag }
                  isExpandable={ isExpandable }
                  nestedListProps={ nestedListProps }
                  requiredListQIds={ isEditMode ? getRequiredListQIds(item) : [] }
                  currentListAnswerIndex={ currentListAnswerIndex }
                  callBackButtonAction={ callBackButtonAction }
                />
              );
            })
          : null}
        {pendingQuestionsLength <= 0 &&
          !disableAddButton &&
          listEditQId !== listId &&
          renderAddListItemButton()}
      </Wrapper>
    </ListQuestionCardWrapper>
  );
}

const mapStateToProps = (state) => {
  const { isListAddAction, listEditIndex, listEditQId, listIndex, editingChildListIndex } = get(
    state,
    'questions',
  );
  // const { sectionIndex, requiredListQIds, listQIds } = props;
  // const { activeSubsectionId } = get(state, 'questions');
  // const enableUpdate = getEnableAdd(
  //   state,
  //   sectionIndex,
  //   activeSubsectionId,
  //   requiredListQIds,
  //   listQIds,
  // );
  return {
    isListAddAction,
    listEditIndex,
    listEditQId,
    // enableUpdate,
    listIndex,
    editingChildListIndex,
  };
};

function mapDispatchToProps(dispatch, props) {
  const { listId } = props;
  return {
    handleAddListItem: (parentListIndex, questionsLength, isNestedQ) => {
      const childListIndex = isNestedQ ? questionsLength : null;
      const { listParentId } = props;
      dispatch(
        setCurrentEditListIndices(
          parentListIndex,
          childListIndex,
          props.sectionIndex,
          true,
          listParentId,
        ),
      );
      if (isNestedQ) {
        dispatch(setOuterListActionButton(false, props.sectionIndex));
      }
      dispatch(getNextListItemForm(props.sectionIndex, listId, `list-add-item-btn-${listId}`));
    },
    // handleAddListItem: () => {
    //   dispatch(getNextListItemForm(props.sectionIndex, listId, `list-add-item-btn-${listId}`));
    // },
    handleDelete: (index, sectionIndex) => {
      dispatch(deleteBeneficiary(index, sectionIndex, listId, `list-delete-btn-${listId}`));
    },
    handleUpdate: (sectionIndex, index, listQ, parentListIndex, isNestedQ) => {
      dispatch(setListIndex(index));
      const listQIds = listQ.map((q) => q.question_id);
      dispatch(
        addListItem(
          sectionIndex,
          index,
          listQIds,
          listId,
          `list-update-btn-${listId}`,
          parentListIndex,
          isNestedQ,
        ),
      );
    },
    updateListIndex: (index) => {
      dispatch(setListIndex(index));
    },
    updateReflexiveListIndex: (index, id) => {
      dispatch(setReflexiveListIndex(index, id));
    },
    handleCancel: (sectionIndex, index, listQ, editingChildListIndex) => {
      const listQIds = listQ.map((q) => q.question_id);
      if (Number.isInteger(editingChildListIndex)) {
        dispatch(closeAddListForm(sectionIndex));
      }
      dispatch(
        listSectionUpdates(sectionIndex, index, listQIds, listId, `list-cancel-btn-${listId}`),
      );
    },
  };
}

export default withTheme(connect(mapStateToProps, mapDispatchToProps)(ListQuestionCard));
